import React, { useEffect } from "react";
import config from "../../../../config";
import useApi from "../../../../api"; // Components

import Map from "../../../../components/Map";
import Button from "../../../../components/Button";

var PackagePlan = function PackagePlan(a) {
  var b = a.package,
      c = a.getMainImage,
      d = useApi(),
      e = "apartment" === b.propertyType,
      f = "townhome" === b.propertyType,
      g = d.neighbourhoods.retrieve(b.neighbourhood_slug),
      h = g.landforsale.find(function (a) {
    var c = a.slug;
    return c === b.release_slug;
  }) || {},
      i = h && h.lots ? h.lots.find(function (a) {
    var c = a.slug;
    return c === b.lot_slug;
  }) : {},
      j = f && d.townhomes.retrieve(b.release_slug),
      k = e && d.buildings.retrieve(b.building),
      l = e && k.levels[b.floor_number],
      m = e ? [{
    coords: l.apartments,
    image: l.image,
    link: function link(a) {
      return a.slug && config.routes.get("houseandland", a.slug);
    },
    legend: [{
      label: "Available"
    }, {
      label: "Hold",
      className: "builders"
    }, {
      label: "Sold"
    }]
  }, {
    image: k.image
  }] : [];
  e || (f && (j.image && m.push({
    image: j.image
  }), g.image && m.push({
    image: g.image,
    coords: [{
      coords: j.coords
    }],
    active: j.coords
  })), !f && (i && i.image && m.push({
    image: i.image
  }), h && h.image && m.push({
    image: h.image,
    coords: [{
      coords: i.coords
    }],
    active: i.coords
  }), g && g.image && m.push({
    image: g.image,
    coords: [{
      coords: h.coords
    }],
    active: h.coords
  })), m.push({
    image: g.plan,
    coords: [{
      coords: g.coords
    }],
    active: g.coords
  })), m = m.filter(function (a) {
    return a.image && a.image.url;
  }), useEffect(function () {
    if ("function" == typeof c) {
      var a = m[0].image.url;
      a && c(a);
    }
  }, [m, c]);
  var n = config.downloads.get("masterplan"),
      o = config.downloads.get("design_guidelines"),
      p = config.downloads.get("due_diligence"),
      q = n ? n : g.masterplan,
      r = o ? o : g.design_guidelines_flyer,
      s = p ? p : g.duediligence_flyer;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Map, {
    levels: m,
    active: b.slug,
    showLabel: !0
  }), q || r || s ? /*#__PURE__*/React.createElement("div", {
    className: "lfs--downloads"
  }, /*#__PURE__*/React.createElement("h4", null, "Downloads"), q && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    href: q,
    icon: "download",
    color: "secondary",
    external: !0
  }, "Masterplan"), r && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    href: r,
    icon: "download",
    color: "secondary",
    external: !0
  }, "Design guidelines"), s && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    href: s,
    icon: "download",
    color: "secondary",
    external: !0
  }, "Due Diligence")) : null);
};

export default PackagePlan;